import styled from "styled-components";

import { colors } from "shared/ui";

// Переключатель языков — по содержимому: во flex-колонке он иначе растягивается на всю ширину.
export const LangRow = styled.div`
    display: flex;
`;

export const Hint = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;
